module.exports = __webpack_public_path__ + "img/las Prlekija.39712e92.jpg";